// // System
// import React, { useEffect, useMemo } from 'react';

// // Components
// import { TablePagination } from '@mui/material';
// import { TableBodyEx, TableContainerEx, TableEx } from '@Components/shared/tables/components';
// import {
//   ColumnVisibilityPresenter,
//   TableHeadColumnsPresenter,
//   TableHeadPresenter,
//   TableRowPresenter,
// } from '@Components/shared/tables/presenters';
// import { LoadingScreen } from '@Components/shared/loaders/LoadingScreen';

// // Utils
// import { applyColumnVisibility } from '@utils/data/applyColumnVisibility';

// //  Table
// import { useRoundTableColumns } from './useRoundsTableColumns';

// // Redux
// import { useDispatch } from 'react-redux';
// import { RoundItemDto } from '@contracts/api/dto/rounds/RoundsDto';
// import { useRoundsTable } from '@Modal/hooks/rounds/useRoundsTable';

// // Graphql
// import { usePaginatedAviatorRoundsQuery } from '@Src/generated.graphql';

// // Hooks
// import { useRoundDrawer } from '@Modal/hooks/rounds/useRoundDrawer';
// import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
// import { formatPaginationTotal } from '@utils/data/number/localeNumberFormat';

// export const RoundsTable: React.FC = () => {
//   const dispatch = useDispatch();
//   const {
//     roundsListFilters,
//     columnVisibility,
//     visiblityCustomizable,
//     limit,
//     total,
//     page,
//     setLimit,
//     setPage,
//     setTotal,
//     roundTableFilters,
//   } = useRoundsTable();
//   const columns = useRoundTableColumns();
//   const { handleRoundRowClick } = useRoundDrawer();
//   const { userPermissions } = useAuthorization();
//   const permissionToViewRounds = userPermissions?.includes('CAN_VIEW_AVIATOR_ROUNDS');

//   const { data, loading, refetch } = usePaginatedAviatorRoundsQuery({
//     variables: {
//       limit,
//       page,
//       filter: roundTableFilters,
//     },
//     skip: !permissionToViewRounds,
//   });

//   const visibleColumns = useMemo(
//     () => applyColumnVisibility(columns, roundsListFilters),
//     [columns, columnVisibility]
//   );

//   useEffect(() => {
//     if (data?.paginatedAviatorRounds) {
//       const { total, limit, page } = data.paginatedAviatorRounds;
//       dispatch(setTotal(total));
//       dispatch(setLimit(limit));
//       dispatch(setPage(page));
//     }
//   }, [data]);

//   const header = useMemo(
//     () => (
//       <TableHeadPresenter>
//         <TableHeadColumnsPresenter columns={visibleColumns} />
//         {/* @ts-ignore */}
//         <ColumnVisibilityPresenter columns={columns} content={visiblityCustomizable} />
//       </TableHeadPresenter>
//     ),
//     [columns]
//   );

//   if (!permissionToViewRounds) return <h1>No Permission</h1>;
//   if (loading) return <LoadingScreen />;

//   const handlePageChange = (event: unknown, newPage: number) => {
//     dispatch(setPage(newPage + 1));
//     refetch();
//   };

//   const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     dispatch(setLimit(parseInt(event.target.value, 10)));
//     dispatch(setPage(1));
//     refetch();
//   };

//   return (
//     <>
//       <TableContainerEx sx={{ height: '70vh' }} pageNumber={1}>
//         <TableEx name="RoundsList">
//           {header}
//           <TableBodyEx>
//             {/* @ts-ignore */}
//             {data?.paginatedAviatorRounds?.docs.map((row: RoundItemDto) => (
//               <TableRowPresenter
//                 id={row._id}
//                 key={row._id}
//                 columns={visibleColumns}
//                 row={row}
//                 onClick={() => handleRoundRowClick(row._id)}
//               />
//             ))}
//           </TableBodyEx>
//         </TableEx>
//       </TableContainerEx>
//       <TableEx name="CustomerListFooter">
//         <TablePagination
//           component="div"
//           count={total}
//           page={page - 1}
//           rowsPerPage={limit}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleRowsPerPageChange}
//           labelDisplayedRows={({ from, to, count }) =>
//             `${from}-${to} of ${formatPaginationTotal(count)}`
//           }
//         />
//       </TableEx>
//     </>
//   );
// };

export const RoundsTable: React.FC = () => {
  return <div>Mines Does not have rounds table</div>;
};
